
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'

@Observer
@Component({
  scrollToTop: true,
  components: {
    InfiniteLoading
  }
})
export default class PageView extends Vue {
  body = null
  get PageStore() {
    return this.$store.$my
  }
  get pagePagination() {
    return this.PageStore.MyCoin
  }
  tongBanType(useWay: number, coin: number) {
    /*
      数据迁移获得(0, "数据迁移获得"),
      买课消耗(1, "买课消耗"),
      买课获得(2, "买课获得"),

      取消订单获得(3, "取消订单获得"),

      退课消耗(5, "退课消耗"),
      退课获得(6, "退课获得"),

      取消退课获得(7, "取消退课获得"),
      取消退课消耗(8, "取消退课消耗"),

      系统赠送(9, "系统赠送"),

      积分补偿获得(10, "积分补偿获得"),

      系统处理(12, "系统处理"),
    */

    let types = [
      ['买课', '获得'],
      ['买课', '消耗'],
      ['买课', '获得'],
      ['取消订单', '获得'],
      ['', ''],
      ['退课', '消耗'],
      ['退课', '获得'],
      ['取消退课', '获得'],
      ['取消退课', '消耗'],
      ['系统', '赠送'],
      ['积分补偿', '获得'],
      ['桐板儿兑换', '消耗'],
      ['', '']
    ]

    if (useWay > types.length) return ['', '']

    // 根据coin正负数来判断‘获得’还是‘消耗’
    if (useWay === 12) {
      return coin > 0 ? ['系统返还', '获得'] : ['系统扣回', '消耗']
    }

    return types[useWay]
  }
  created() {}
  mounted() {}
  beforeDestroy() {}
}
